export default {
  'Badge.BadgeWrapper.Buttons.SecondaryButton': ({ }, outlet) => {
    outlet({ action: 'secondary' });
  },
  'Badge.BadgeWrapper.Buttons.PrimaryButton': ({ }, outlet) => {
    outlet({ action: 'primary' });
  }
}